import React, { useEffect, useState } from 'react';


import Header from '../../components/Header';

import { colors, radius, shadows } from '../../styles/theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token
    ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    : { 'Content-Type': 'application/json' };
};

const formatMoney = (value) => {
  const num = Number(value || 0);
  return num.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const LogoFaturaOnizlemePage = () => {
  const today = new Date();
  const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [baslangic, setBaslangic] = useState(firstOfMonth.toISOString().split('T')[0]);
  const [bitis, setBitis] = useState(today.toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);
  const [aktarLoading, setAktarLoading] = useState(false);
  const [data, setData] = useState(null);
  const [hata, setHata] = useState('');
  const [basariMesaji, setBasariMesaji] = useState('');
  const [seciliFatura, setSeciliFatura] = useState(null);

  const [eslestirmeAcik, setEslestirmeAcik] = useState(false);
  const [eslesKalem, setEslesKalem] = useState(null);
  const [hedefTur, setHedefTur] = useState('MALZEME');
  const [arama, setArama] = useState('');
  const [hedefler, setHedefler] = useState([]);
  const [hedefLoading, setHedefLoading] = useState(false);
  const [seciliHedefId, setSeciliHedefId] = useState('');
  const [kaydetLoading, setKaydetLoading] = useState(false);
  const [modalHata, setModalHata] = useState('');

  const seciliFaturaNo = seciliFatura?.logo?.fatura_no || null;

  const cardStyle = {
    background: colors?.white || '#fff',
    borderRadius: radius?.lg || 10,
    boxShadow: shadows?.sm || '0 1px 3px rgba(0,0,0,0.08)',
    padding: 18,
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 14,
  };

  const thStyle = {
    textAlign: 'left',
    padding: '10px 8px',
    borderBottom: '1px solid #ddd',
    background: '#f7f7f7',
  };

  const tdStyle = {
    padding: '10px 8px',
    borderBottom: '1px solid #eee',
    verticalAlign: 'top',
  };

  const inputStyle = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '10px 11px',
    border: '1px solid #cfcfcf',
    borderRadius: 7,
    background: '#fff',
  };

  const primaryButton = {
    padding: '9px 14px',
    border: 0,
    borderRadius: 7,
    background: '#1a73e8',
    color: '#fff',
    fontWeight: 700,
    cursor: 'pointer',
  };

  const secondaryButton = {
    padding: '9px 14px',
    border: '1px solid #c7c7c7',
    borderRadius: 7,
    background: '#fff',
    color: '#333',
    fontWeight: 600,
    cursor: 'pointer',
  };

  const durumRengi = (durum) => {
    if (durum === 'AKTARIMA_HAZIR') return '#137333';
    if (durum === 'HATALI_VEYA_EKSIK') return '#b06000';
    if (durum === 'HATA') return '#b3261e';
    return '#555';
  };

  const onizlemeGetir = async (korunacakFaturaNo = null) => {
    setLoading(true);
    setHata('');
    setBasariMesaji('');

    try {
      const url =
        `${API_URL}/api/logo/onizleme/giden` +
        `?baslangic=${encodeURIComponent(baslangic)}` +
        `&bitis=${encodeURIComponent(bitis)}`;

      const res = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      const body = await res.json();

      if (!res.ok) {
        throw new Error(body?.detail || body?.message || `HTTP ${res.status}`);
      }

      setData(body);

      const liste = body?.faturalar || [];
      const aranacakNo = korunacakFaturaNo || seciliFaturaNo;

      if (aranacakNo) {
        const yenidenSec = liste.find(
          (x) => x?.logo?.fatura_no === aranacakNo
        );
        setSeciliFatura(yenidenSec || liste[0] || null);
      } else {
        setSeciliFatura(liste[0] || null);
      }
    } catch (err) {
      setHata(err.message || 'Önizleme alınamadı');
    } finally {
      setLoading(false);
    }
  };

  const faturayiErpyeAktar = async (fatura = seciliFatura) => {
    const faturaNo = fatura?.logo?.fatura_no || null;
    if (!faturaNo || !fatura) return;

    if (fatura?.durum !== 'AKTARIMA_HAZIR') {
      setHata('Bu fatura henüz aktarıma hazır değil. Önce kritik uyarıları giderin.');
      setSeciliFatura(fatura);
      return;
    }

    setSeciliFatura(fatura);
    setAktarLoading(true);
    setHata('');
    setBasariMesaji('');

    try {
      const res = await fetch(`${API_URL}/api/logo/senk/giden/tek`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          logo_fatura_id: faturaNo,
          baslangic,
          bitis,
        }),
      });

      const body = await res.json();

      if (!res.ok) {
        const detail = body?.detail;
        const mesaj =
          (typeof detail === 'string' && detail) ||
          detail?.hata ||
          detail?.message ||
          body?.message ||
          `HTTP ${res.status}`;
        throw new Error(mesaj);
      }

      const sonuc = body?.sonuc || body;
      const hatalar = sonuc?.hatalar || [];
      const senkronize = Number(sonuc?.senkronize || 0);

      if (body?.ok === false || hatalar.length > 0 || senkronize < 1) {
        const ilkHata = hatalar?.[0]?.hata;
        throw new Error(ilkHata || body?.message || 'Fatura ERP’ye aktarılamadı');
      }

      setData((prev) => {
        if (!prev) return prev;

        const yeniListe = (prev.faturalar || []).filter(
          (x) => x?.logo?.fatura_no !== faturaNo
        );

        return {
          ...prev,
          faturalar: yeniListe,
          toplam_fatura: yeniListe.length,
          aktarima_hazir: yeniListe.filter(
            (x) => x?.durum === 'AKTARIMA_HAZIR'
          ).length,
          sorunlu: yeniListe.filter(
            (x) => x?.durum !== 'AKTARIMA_HAZIR'
          ).length,
        };
      });

      setSeciliFatura((prev) =>
        prev?.logo?.fatura_no === faturaNo ? null : prev
      );
      setBasariMesaji(`Fatura ${faturaNo} ERP’ye aktarıldı.`);
    } catch (err) {
      setHata(err.message || 'Fatura ERP’ye aktarılamadı');
    } finally {
      setAktarLoading(false);
    }
  };

  const eslestirmeAc = (kalem) => {
    setEslesKalem(kalem);
    setHedefTur('MALZEME');
    setArama(kalem?.logo?.urun_adi || '');
    setHedefler([]);
    setSeciliHedefId('');
    setModalHata('');
    setEslestirmeAcik(true);
  };

  const eslestirmeKapat = () => {
    if (kaydetLoading) return;
    setEslestirmeAcik(false);
    setEslesKalem(null);
    setHedefler([]);
    setSeciliHedefId('');
    setModalHata('');
  };

  const hedefleriGetir = async () => {
    if (!eslestirmeAcik || hedefTur === 'YOK_SAY') {
      setHedefler([]);
      setSeciliHedefId('');
      return;
    }

    setHedefLoading(true);
    setModalHata('');

    try {
      const url =
        `${API_URL}/api/logo/fatura-urun-hedefleri` +
        `?tur=${encodeURIComponent(hedefTur)}` +
        `&q=${encodeURIComponent(arama || '')}`;

      const res = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      const body = await res.json();

      if (!res.ok) {
        throw new Error(body?.detail || body?.message || `HTTP ${res.status}`);
      }

      const rows = body?.sonuclar || [];
      setHedefler(rows);

      if (rows.length === 1) {
        setSeciliHedefId(String(rows[0].id));
      } else {
        setSeciliHedefId('');
      }
    } catch (err) {
      setModalHata(err.message || 'ERP hedefleri alınamadı');
      setHedefler([]);
    } finally {
      setHedefLoading(false);
    }
  };

  useEffect(() => {
    if (!eslestirmeAcik) return;

    const timer = setTimeout(() => {
      hedefleriGetir();
    }, 250);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eslestirmeAcik, hedefTur, arama]);

  const eslestirmeKaydet = async () => {
    if (!eslesKalem) return;

    if (hedefTur !== 'YOK_SAY' && !seciliHedefId) {
      setModalHata('Bir ERP kaydı seçmelisiniz.');
      return;
    }

    setKaydetLoading(true);
    setModalHata('');

    try {
      const payload = {
        logo_urun_kodu: eslesKalem?.logo?.urun_kodu || null,
        logo_urun_adi: eslesKalem?.logo?.urun_adi || '',
        hedef_tur: hedefTur,
        hedef_id:
          hedefTur === 'YOK_SAY' ? null : Number(seciliHedefId),
      };

      const res = await fetch(
        `${API_URL}/api/logo/fatura-urun-eslestirme`,
        {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify(payload),
        }
      );

      const body = await res.json();

      if (!res.ok) {
        throw new Error(body?.detail || body?.message || `HTTP ${res.status}`);
      }

      const faturaNo = seciliFaturaNo;
      eslestirmeKapat();

      // Kaydettikten sonra önizlemeyi yeniden çalıştır.
      // Böylece satır EŞLEŞMEDİ durumundan gerçek ERP hedefine geçer.
      await onizlemeGetir(faturaNo);
    } catch (err) {
      setModalHata(err.message || 'Eşleştirme kaydedilemedi');
    } finally {
      setKaydetLoading(false);
    }
  };

  return (
    <div>
      <Header
        title="Fatura Önizleme"
        subtitle="Logo İşbaşı giden faturalarını kontrol edin, eşleştirin ve ERP'ye aktarın"
      />

      <div style={{ ...cardStyle, marginTop: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'end', flexWrap: 'wrap' }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, marginBottom: 6, color: '#555' }}>
              Başlangıç
            </label>
            <input
              type="date"
              value={baslangic}
              onChange={(e) => setBaslangic(e.target.value)}
              style={{ padding: '9px 10px', border: '1px solid #ccc', borderRadius: 6 }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 13, marginBottom: 6, color: '#555' }}>
              Bitiş
            </label>
            <input
              type="date"
              value={bitis}
              onChange={(e) => setBitis(e.target.value)}
              style={{ padding: '9px 10px', border: '1px solid #ccc', borderRadius: 6 }}
            />
          </div>

          <button
            onClick={() => onizlemeGetir()}
            disabled={loading}
            style={{
              ...primaryButton,
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? 0.65 : 1,
            }}
          >
            {loading ? 'Yükleniyor...' : 'Önizlemeyi Getir'}
          </button>
        </div>

        {hata && (
          <div
            style={{
              marginTop: 16,
              padding: 12,
              background: '#fdecea',
              border: '1px solid #f3b8b3',
              borderRadius: 6,
              color: '#b3261e',
            }}
          >
            {hata}
          </div>
        )}

        {basariMesaji && (
          <div
            style={{
              marginTop: 16,
              padding: 12,
              background: '#e6f4ea',
              border: '1px solid #a8d5b5',
              borderRadius: 6,
              color: '#137333',
            }}
          >
            {basariMesaji}
          </div>
        )}
      </div>

      {data && (
        <>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
              gap: 12,
              marginTop: 16,
            }}
          >
            <div style={cardStyle}>
              <div style={{ color: '#666', fontSize: 13 }}>Toplam Fatura</div>
              <div style={{ fontSize: 26, fontWeight: 700 }}>{data.toplam_fatura || 0}</div>
            </div>
            <div style={cardStyle}>
              <div style={{ color: '#666', fontSize: 13 }}>Aktarıma Hazır</div>
              <div style={{ fontSize: 26, fontWeight: 700 }}>{data.aktarima_hazir || 0}</div>
            </div>
            <div style={cardStyle}>
              <div style={{ color: '#666', fontSize: 13 }}>Sorunlu</div>
              <div style={{ fontSize: 26, fontWeight: 700 }}>{data.sorunlu || 0}</div>
            </div>
          </div>

          <div style={{ ...cardStyle, marginTop: 16, overflowX: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>Logo Giden Faturalar</h3>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Tarih</th>
                  <th style={thStyle}>Fatura No</th>
                  <th style={thStyle}>Cari</th>
                  <th style={thStyle}>VKN/TCKN</th>
                  <th style={thStyle}>Toplam</th>
                  <th style={thStyle}>Kalem</th>
                  <th style={thStyle}>Durum</th>
                  <th style={thStyle}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {(data.faturalar || []).map((fatura, index) => (
                  <tr
                    key={`${fatura?.logo?.fatura_no}-${index}`}
                    onClick={() => setSeciliFatura(fatura)}
                    style={{
                      cursor: 'pointer',
                      background:
                        seciliFatura?.logo?.fatura_no === fatura?.logo?.fatura_no
                          ? '#f1f5ff'
                          : 'transparent',
                    }}
                  >
                    <td style={tdStyle}>{fatura?.logo?.fatura_tarihi_okunan || '-'}</td>
                    <td style={tdStyle}>{fatura?.logo?.fatura_no || '-'}</td>
                    <td style={tdStyle}>{fatura?.logo?.cari_unvan || '-'}</td>
                    <td style={tdStyle}>{fatura?.logo?.alici_vkn_tckn || '-'}</td>
                    <td style={tdStyle}>{formatMoney(fatura?.logo?.toplam_brut)}</td>
                    <td style={tdStyle}>{fatura?.kalemler?.length || 0}</td>
                    <td
                      style={{
                        ...tdStyle,
                        color: durumRengi(fatura?.durum),
                        fontWeight: 700,
                      }}
                    >
                      {fatura?.durum || '-'}
                    </td>
                    <td style={tdStyle}>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSeciliFatura(fatura);
                            onizlemeGetir(fatura?.logo?.fatura_no);
                          }}
                          disabled={loading || aktarLoading}
                          style={{
                            ...secondaryButton,
                            padding: '7px 11px',
                            opacity: loading || aktarLoading ? 0.6 : 1,
                          }}
                        >
                          Güncelle
                        </button>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            faturayiErpyeAktar(fatura);
                          }}
                          disabled={
                            loading ||
                            aktarLoading ||
                            fatura?.durum !== 'AKTARIMA_HAZIR'
                          }
                          style={{
                            ...primaryButton,
                            padding: '7px 11px',
                            background:
                              fatura?.durum === 'AKTARIMA_HAZIR'
                                ? '#137333'
                                : '#9aa0a6',
                            opacity: loading || aktarLoading ? 0.6 : 1,
                            cursor:
                              fatura?.durum === 'AKTARIMA_HAZIR' &&
                              !loading &&
                              !aktarLoading
                                ? 'pointer'
                                : 'not-allowed',
                          }}
                          title={
                            fatura?.durum === 'AKTARIMA_HAZIR'
                              ? 'Faturayı ERP’ye aktar ve listeden kaldır'
                              : 'Fatura aktarıma hazır değil'
                          }
                        >
                          {aktarLoading &&
                          seciliFatura?.logo?.fatura_no === fatura?.logo?.fatura_no
                            ? 'Aktarılıyor...'
                            : 'ERP’ye Aktar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          

          
        </>
      )}

      {seciliFatura && (
        <>
          <div style={{ ...cardStyle, marginTop: 16, overflowX: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>Fatura Kalemleri / Stok / Fiyat</h3>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Logo Ürün</th>
                  <th style={thStyle}>Kod</th>
                  <th style={thStyle}>Miktar</th>
                  <th style={thStyle}>Logo Birim Fiyat</th>
                  <th style={thStyle}>ERP Malzeme / Reçete</th>
                  <th style={thStyle}>ERP Fatura Fiyatı</th>
                  <th style={thStyle}>Stok İşlemi</th>
                  <th style={thStyle}>InternalSale Fiyat</th>
                  <th style={thStyle}>Düzeltme</th>
                </tr>
              </thead>
              <tbody>
                {(seciliFatura?.kalemler || []).map((kalem, index) => {
                  const eslesmis = Boolean(kalem?.erp?.malzeme);

                  return (
                    <tr
                      key={index}
                      style={{
                        background: eslesmis ? 'transparent' : '#fff8f7',
                      }}
                    >
                      <td style={tdStyle}>{kalem?.logo?.urun_adi || '-'}</td>
                      <td style={tdStyle}>{kalem?.logo?.urun_kodu || '-'}</td>
                      <td style={tdStyle}>
                        {kalem?.logo?.miktar || 0} {kalem?.logo?.birim || ''}
                      </td>
                      <td style={tdStyle}>{formatMoney(kalem?.logo?.birim_fiyat)}</td>
                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: eslesmis ? 500 : 700,
                          color: eslesmis ? '#333' : '#b3261e',
                        }}
                      >
                        {kalem?.erp?.malzeme?.ad || 'EŞLEŞMEDİ'}
                        {kalem?.erp?.malzeme?.hedef_tablo &&
                          kalem?.erp?.malzeme?.hedef_tablo !== 'MALZEME' && (
                            <div style={{ fontSize: 12, color: '#666', marginTop: 3 }}>
                              {kalem.erp.malzeme.hedef_tablo}
                            </div>
                          )}
                      </td>
                      <td style={tdStyle}>
                        {kalem?.erp?.fatura_kalemi
                          ? formatMoney(kalem.erp.fatura_kalemi.birim_fiyat)
                          : '-'}
                      </td>
                      <td style={tdStyle}>{kalem?.erp?.stok_transfer?.durum || '-'}</td>
                      <td style={tdStyle}>
                        {kalem?.erp?.fiyat_etkisi?.internal_sale_transfer_price != null
                          ? formatMoney(
                              kalem.erp.fiyat_etkisi.internal_sale_transfer_price
                            )
                          : '-'}
                      </td>
                      <td style={tdStyle}>
                        <button
                          onClick={() => eslestirmeAc(kalem)}
                          style={{
                            ...primaryButton,
                            padding: '7px 11px',
                            background: eslesmis ? '#5f6368' : '#1a73e8',
                          }}
                        >
                          {eslesmis ? 'Değiştir' : 'Eşleştir'}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {((seciliFatura?.uyarilar || []).length > 0 ||
            (seciliFatura?.kalemler || []).some((k) => (k?.uyarilar || []).length > 0)) && (
            <div
              style={{
                ...cardStyle,
                marginTop: 16,
                background: '#fff7f6',
                border: '1px solid #f3b8b3',
              }}
            >
              <h3 style={{ marginTop: 0, color: '#b3261e' }}>Uyarılar</h3>

              {(seciliFatura?.uyarilar || []).map((uyari, index) => (
                <div key={`f-${index}`} style={{ marginBottom: 8 }}>
                  <strong>{uyari?.seviye || 'UYARI'}</strong>
                  {uyari?.alan ? ` — ${uyari.alan}` : ''}: {uyari?.mesaj || '-'}
                </div>
              ))}

              {(seciliFatura?.kalemler || []).map((kalem, kalemIndex) =>
                (kalem?.uyarilar || []).map((uyari, uyariIndex) => (
                  <div key={`k-${kalemIndex}-${uyariIndex}`} style={{ marginBottom: 8 }}>
                    <strong>{uyari?.seviye || 'UYARI'}</strong>
                    {' — '}
                    {kalem?.logo?.urun_adi || `Kalem ${kalemIndex + 1}`}: {uyari?.mesaj || '-'}
                  </div>
                ))
              )}
            </div>
          )}

          <div style={{ ...cardStyle, marginTop: 16 }}>
            <h3 style={{ marginTop: 0 }}>Logo → ERP Kontrolü</h3>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Alan</th>
                  <th style={thStyle}>Logo'da Gelen</th>
                  <th style={thStyle}>ERP'de Kullanılacak</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tdStyle}>Fatura No</td>
                  <td style={tdStyle}>{seciliFatura?.logo?.fatura_no || '-'}</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.satis_faturasi?.fatura_no || '-'}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Fatura Tarihi</td>
                  <td style={tdStyle}>{seciliFatura?.logo?.issue_date_ham || '-'}</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.satis_faturasi?.tarih || '-'}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Cari</td>
                  <td style={tdStyle}>{seciliFatura?.logo?.cari_unvan || '-'}</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.cari?.unvan || 'EŞLEŞMEDİ'}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>VKN/TCKN</td>
                  <td style={tdStyle}>{seciliFatura?.logo?.alici_vkn_tckn || '-'}</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.cari?.vergi_no || '-'}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Net</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.logo?.net_tutar)}</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.erp?.satis_faturasi?.net_tutar)}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>KDV</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.logo?.kdv_tutar)}</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.erp?.satis_faturasi?.kdv_tutar)}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Brüt Toplam</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.logo?.toplam_brut)}</td>
                  <td style={tdStyle}>{formatMoney(seciliFatura?.erp?.satis_faturasi?.brut_tutar)}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Kaynak Lokasyon</td>
                  <td style={tdStyle}>—</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.kaynak_lokasyon?.ad || '-'}</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Hedef Lokasyon</td>
                  <td style={tdStyle}>—</td>
                  <td style={tdStyle}>{seciliFatura?.erp?.hedef_lokasyon?.ad || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ ...cardStyle, marginTop: 16 }}>
            <h3 style={{ marginTop: 0 }}>Açık Alacak Önizleme</h3>
            <table style={tableStyle}>
              <tbody>
                <tr><td style={tdStyle}>İşlem</td><td style={tdStyle}>{seciliFatura?.alacak?.islem || '-'}</td></tr>
                <tr><td style={tdStyle}>Alacak Tarihi</td><td style={tdStyle}>{seciliFatura?.alacak?.alacak_tarihi || '-'}</td></tr>
                <tr><td style={tdStyle}>Vade Tarihi</td><td style={tdStyle}>{seciliFatura?.alacak?.vade_tarihi || '-'}</td></tr>
                <tr><td style={tdStyle}>Orijinal Tutar</td><td style={tdStyle}>{formatMoney(seciliFatura?.alacak?.orjinal_tutar)}</td></tr>
                <tr><td style={tdStyle}>Kalan Tutar</td><td style={tdStyle}>{formatMoney(seciliFatura?.alacak?.kalan_tutar)}</td></tr>
                <tr><td style={tdStyle}>Durum</td><td style={tdStyle}>{seciliFatura?.alacak?.durum || '-'}</td></tr>
              </tbody>
            </table>
          </div>

        </>
      )}

{(data?.islem_yapilanlar || []).length > 0 && (
            <div style={{ ...cardStyle, marginTop: 16, overflowX: 'auto' }}>
              <h3 style={{ marginTop: 0 }}>İşlem Yapılanlar</h3>

              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>Tarih</th>
                    <th style={thStyle}>Fatura No</th>
                    <th style={thStyle}>Cari</th>
                    <th style={thStyle}>Toplam</th>
                    <th style={thStyle}>Durum</th>
                  </tr>
                </thead>

                <tbody>
                  {(data?.islem_yapilanlar || []).map((fatura, index) => (
                    <tr
                      key={`islem-${fatura?.logo?.fatura_no}-${index}`}
                    >
                      <td style={tdStyle}>
                        {fatura?.logo?.fatura_tarihi_okunan || '-'}
                      </td>

                      <td style={tdStyle}>
                        {fatura?.logo?.fatura_no || '-'}
                      </td>

                      <td style={tdStyle}>
                        {fatura?.logo?.cari_unvan || '-'}
                      </td>

                      <td style={tdStyle}>
                        {formatMoney(fatura?.logo?.toplam_brut)}
                      </td>

                      <td
                        style={{
                          ...tdStyle,
                          color: '#137333',
                          fontWeight: 700,
                        }}
                      >
                        ERP’YE AKTARILDI
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

      {eslestirmeAcik && (
        <div
          onClick={eslestirmeKapat}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.38)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 18,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(760px, 96vw)',
              maxHeight: '88vh',
              overflowY: 'auto',
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 14px 40px rgba(0,0,0,0.22)',
              padding: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'start',
                gap: 12,
              }}
            >
              <div>
                <h3 style={{ margin: 0 }}>Fatura Ürün Eşleştirme</h3>
                <div style={{ marginTop: 8, color: '#555' }}>
                  <strong>{eslesKalem?.logo?.urun_adi || '-'}</strong>
                  {' · '}
                  {eslesKalem?.logo?.urun_kodu || 'Kod yok'}
                </div>
              </div>

              <button
                onClick={eslestirmeKapat}
                style={{
                  border: 0,
                  background: 'transparent',
                  fontSize: 24,
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '180px 1fr',
                gap: 14,
                marginTop: 20,
              }}
            >
              <div>
                <label style={{ display: 'block', fontSize: 13, marginBottom: 6 }}>
                  Hedef Türü
                </label>
                <select
                  value={hedefTur}
                  onChange={(e) => {
                    setHedefTur(e.target.value);
                    setSeciliHedefId('');
                    setHedefler([]);
                  }}
                  style={inputStyle}
                >
                  <option value="MALZEME">Malzeme</option>
                  <option value="RECETE">Reçete</option>
                  <option value="YOK_SAY">Yok Say</option>
                </select>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, marginBottom: 6 }}>
                  ERP Arama
                </label>
                <input
                  type="text"
                  value={arama}
                  onChange={(e) => setArama(e.target.value)}
                  disabled={hedefTur === 'YOK_SAY'}
                  placeholder={
                    hedefTur === 'RECETE'
                      ? 'Reçete adı ara...'
                      : 'Malzeme adı veya kod ara...'
                  }
                  style={{
                    ...inputStyle,
                    background: hedefTur === 'YOK_SAY' ? '#f3f3f3' : '#fff',
                  }}
                />
              </div>
            </div>

            {hedefTur === 'YOK_SAY' ? (
              <div
                style={{
                  marginTop: 18,
                  padding: 14,
                  background: '#fff8e1',
                  border: '1px solid #f3d27a',
                  borderRadius: 8,
                  color: '#7a5a00',
                }}
              >
                Bu ürün bilerek stok/fatura ürün eşleştirmesine dahil edilmeyecek.
              </div>
            ) : (
              <div style={{ marginTop: 18 }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 8,
                  }}
                >
                  <strong>
                    {hedefTur === 'RECETE' ? 'Reçeteler' : 'Malzemeler'}
                  </strong>
                  <span style={{ color: '#666', fontSize: 13 }}>
                    {hedefLoading ? 'Aranıyor...' : `${hedefler.length} sonuç`}
                  </span>
                </div>

                <div
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    maxHeight: 300,
                    overflowY: 'auto',
                  }}
                >
                  {!hedefLoading && hedefler.length === 0 && (
                    <div style={{ padding: 16, color: '#777' }}>
                      Sonuç bulunamadı.
                    </div>
                  )}

                  {hedefler.map((hedef) => {
                    const selected = String(seciliHedefId) === String(hedef.id);

                    return (
                      <label
                        key={`${hedefTur}-${hedef.id}`}
                        style={{
                          display: 'flex',
                          gap: 10,
                          alignItems: 'center',
                          padding: '11px 12px',
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                          background: selected ? '#eef5ff' : '#fff',
                        }}
                      >
                        <input
                          type="radio"
                          name="logo-fatura-hedef"
                          checked={selected}
                          onChange={() => setSeciliHedefId(String(hedef.id))}
                        />

                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 650 }}>
                            {hedef.ad || '-'}
                          </div>
                          <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                            {hedefTur === 'MALZEME'
                              ? `${hedef.kod || 'Kod yok'}${hedef.birim ? ` · ${hedef.birim}` : ''}`
                              : `${hedef.tip || 'Reçete'}${hedef.urun_malzeme_id ? ` · Ürün malzeme #${hedef.urun_malzeme_id}` : ''}`}
                          </div>
                        </div>
                      </label>
                    );
                  })}
                </div>
              </div>
            )}

            {modalHata && (
              <div
                style={{
                  marginTop: 14,
                  padding: 12,
                  background: '#fdecea',
                  border: '1px solid #f3b8b3',
                  borderRadius: 7,
                  color: '#b3261e',
                }}
              >
                {modalHata}
              </div>
            )}

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
                marginTop: 20,
              }}
            >
              <button
                onClick={eslestirmeKapat}
                disabled={kaydetLoading}
                style={secondaryButton}
              >
                Vazgeç
              </button>

              <button
                onClick={eslestirmeKaydet}
                disabled={
                  kaydetLoading ||
                  (hedefTur !== 'YOK_SAY' && !seciliHedefId)
                }
                style={{
                  ...primaryButton,
                  opacity:
                    kaydetLoading ||
                    (hedefTur !== 'YOK_SAY' && !seciliHedefId)
                      ? 0.55
                      : 1,
                }}
              >
                {kaydetLoading ? 'Kaydediliyor...' : 'Eşleştirmeyi Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoFaturaOnizlemePage;
